// Sprint CRM-6 — larghezza dello schermo: sotto 1024px menu a scomparsa, CRM e calendario «da telefono»
import { useEffect, useState } from "react";

export const LARGO = 1024;

export function useSchermoLargo(px = LARGO) {
  const q = `(min-width: ${px}px)`;
  const leggi = () => (typeof window === "undefined" || !window.matchMedia ? true : window.matchMedia(q).matches);
  const [largo, setLargo] = useState(leggi);
  useEffect(() => {
    if (typeof window === "undefined" || !window.matchMedia) return undefined;
    const m = window.matchMedia(q);
    const f = () => setLargo(m.matches);
    f();
    m.addEventListener?.("change", f);
    return () => m.removeEventListener?.("change", f);
  }, [q]);
  return largo;
}
